import { render, staticRenderFns } from "./Mentor.vue?vue&type=template&id=78ca3782&scoped=true"
import script from "./Mentor.vue?vue&type=script&lang=js"
export * from "./Mentor.vue?vue&type=script&lang=js"
import style0 from "./Mentor.vue?vue&type=style&index=0&id=78ca3782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ca3782",
  null
  
)

export default component.exports